import styles from "./CountdownBar.module.css";

export interface CountdownBarProps {
  secondsLeft: number;
  secondsTotal: number;
}

function formatTime(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

/**
 * Shared round-timer visual for every minigame that has one (LineUp,
 * Halfway) — a depleting bar, not just a number, so the player can see at a
 * glance (not just read) that time is running out.
 */
export function CountdownBar({ secondsLeft, secondsTotal }: CountdownBarProps) {
  const pct = secondsTotal > 0 ? Math.max(0, Math.min(100, (secondsLeft / secondsTotal) * 100)) : 0;

  return (
    <div
      className={styles.wrapper}
      role="progressbar"
      aria-valuenow={secondsLeft}
      aria-valuemin={0}
      aria-valuemax={secondsTotal}
      aria-label={formatTime(secondsLeft)}
    >
      <div className={styles.track}>
        <div className={styles.fill} style={{ width: `${pct}%` }} />
      </div>
      <span className={styles.time} aria-hidden>
        {formatTime(secondsLeft)}
      </span>
    </div>
  );
}
